<template>
  <div id="data-list-thumb-view" class="data-list-container order-list">
    <vs-table
        ref="table"
        pagination
        :max-items="itemsPerPage"
        search
        :data="orders"
        :total="total"
        :sst="true"
        @search="handleSearch"
        @change-page="getOrders">

      <div slot="header" class="flex flex-wrap-reverse items-center flex-grow justify-between">

        <div class="flex flex-wrap-reverse items-center">

          <!-- ACTION - DROPDOWN -->

          <!-- ADD NEW -->
          <div
              class="p-3 mb-4 mr-4 rounded-lg cursor-pointer flex items-center justify-between text-lg font-medium text-base text-primary border border-solid border-primary"
              @click="addNewData">
            <feather-icon icon="PlusIcon" svgClasses="h-4 w-4"/>
            <span class="ml-2 text-base text-primary" @click="$router.push({'name': 'orders-create'})">Betaalverzoek maken</span>
          </div>
        </div>


        <!-- ITEMS PER PAGE -->
        <vs-dropdown vs-trigger-click class="cursor-pointer mb-4 mr-4">
          <div
              class="p-4 border border-solid d-theme-border-grey-light rounded-full d-theme-dark-bg cursor-pointer flex items-center justify-between font-medium">
            <span class="mr-2">{{
                currentPage * itemsPerPage - (itemsPerPage - 1)
              }} - {{ orders.length - currentPage * itemsPerPage > 0 ? currentPage * itemsPerPage : orders.length }} of {{
                queriedItems
              }}</span>
            <feather-icon icon="ChevronDownIcon" svgClasses="h-4 w-4"/>
          </div>
          <!-- <vs-button class="btn-drop" type="line" color="primary" icon-pack="feather" icon="icon-chevron-down"></vs-button> -->
          <vs-dropdown-menu>

            <vs-dropdown-item @click="itemsPerPage=20">
              <span>20</span>
            </vs-dropdown-item>
            <vs-dropdown-item @click="itemsPerPage=25">
              <span>25</span>
            </vs-dropdown-item>
            <vs-dropdown-item @click="itemsPerPage=50">
              <span>50</span>
            </vs-dropdown-item>
            <vs-dropdown-item @click="itemsPerPage=100">
              <span>100</span>
            </vs-dropdown-item>
          </vs-dropdown-menu>
        </vs-dropdown>
      </div>

      <template slot="thead">
        <vs-th sort-key="id">Number</vs-th>
        <vs-th sort-key="date">Besteldatum</vs-th>
        <vs-th sort-key="adres">Address</vs-th>
        <vs-th sort-key="name">Bedrijf</vs-th>
        <vs-th sort-key="phone-number">Phone Number</vs-th>
      </template>

      <template>
        <tbody>
        <vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in orders" @click.native="editData(tr)">
          <vs-td>
            <p class="order-id font-medium truncate">{{ tr.id }}</p>
          </vs-td>

          <vs-td>
            <p class="order-date">{{ tr.ordered_at_date }} {{ tr.ordered_at }}</p>
          </vs-td>

          <vs-td>
            <p class="order-adres">{{ tr.address.city }} {{ tr.address.streetname }} {{
                tr.address.housenumber
              }}, {{ tr.address.postal_code }}</p>
          </vs-td>

          <vs-td>
            <p class="order-company">{{ tr.company.name }}</p>
          </vs-td>

          <vs-td>
            <p class="order-price">{{
                tr.guest_customer_id != null ? tr.guest_customer.phone_number :
                    tr.customer.phone_number
              }}</p>
          </vs-td>
        </vs-tr>
        </tbody>
      </template>
    </vs-table>

    <vs-popup class="order-modal" :title="activeOrderTitle" :active.sync="popupActive" v-if="activeOrder !== null">
      <vs-tabs alignment="fixed">
        <vs-tab label="Details" :active="true">
          <div class="flex mb-4">
            <div class="w-1/2 bg-grid-color pr-4" :class="{'w-full': activeOrder.job == null}">
              <div>Status: <span style="float: right;">{{ getStatus(activeOrder) }}</span></div>
              <div>Tijd: <span style="float: right;">{{ activeOrder.delivery_time }}</span></div>
              <div>Door: <span style="float: right;">{{ activeOrder.platform }}</span></div>
            </div>
            <div class="w-1/2 bg-grid-color pl-4" v-if="activeOrder.job !== null">
              Bezorger:<span class="float-right">{{ activeOrder.job.deliverer.fullname }}</span>
            </div>
          </div>
          <vs-divider></vs-divider>
          <div class="flex mb-4">
            <div class="w-full bg-grid-color">
              <vs-list>
                <vs-list-item>
                  <template slot="title">
                    Bedrijf:
                  </template>
                  {{ activeOrder.company.name }}
                </vs-list-item>
                <vs-list-item>
                  <template slot="title">
                    Telefoonnummer:
                  </template>
                  {{ activeOrder.company.internal_phone_number }}
                </vs-list-item>
                <vs-list-item>
                  <template slot="title">
                    Adres:
                  </template>
                  {{
                    activeOrder.address.streetname + ' ' + activeOrder.address.housenumber + ', ' +
                    activeOrder.address.postal_code + ' ' + activeOrder.address.city
                  }}
                </vs-list-item>
                <vs-list-item>
                  <template slot="title">
                    Klant:
                  </template>
                  {{
                    activeOrder.customer.insertion !== null ? activeOrder.customer.firstname + ' ' +
                        activeOrder.customer.insertion + ' ' + activeOrder.customer.lastname :
                        activeOrder.customer.firstname + ' ' + activeOrder.customer.lastname
                  }}
                </vs-list-item>
                <vs-list-item v-if="activeOrder.customer.company_name !== null">
                  <template slot="title">
                    Bedrijf:
                  </template>
                  {{ activeOrder.customer.business_name }}
                </vs-list-item>
                <vs-list-item>
                  <template slot="title">
                    Telefoonnummer:
                  </template>
                  {{ activeOrder.customer.phone_number }}
                </vs-list-item>
                <vs-list-item>
                  <template slot="title">
                    Opmerking:
                  </template>
                  {{ activeOrder.note }}
                </vs-list-item>
                <vs-list-item>
                  <template slot="title">
                    Status:
                  </template>
                  {{ activeOrder.status }}
                </vs-list-item>
                <vs-list-item>
                  <template slot="title">
                    Betaalstatus:
                  </template>
                  {{ activeOrder.payment_status }}
                </vs-list-item>
                <vs-list-item>
                  <template slot="title">
                    Totaal({{ activeOrder.payment_method }}):
                  </template>
                  € {{ (activeOrder.price - activeOrder.transaction_fee).toFixed(2) }}
                </vs-list-item>
              </vs-list>
            </div>
          </div>
        </vs-tab>
        <vs-tab label="Bestelling">
          <div>
            <vs-list>
              <vs-list-item v-for="detail in activeOrder.details" :key="detail.id">
                <template slot="title">
                  <p><b>{{ detail.quantity }}x</b> {{ detail.product.name }}</p>
                </template>
                <template slot="subtitle">
                  <ul class="pl-4">
                    <li v-for="addon in detail.addons" :key="addon.id">
                      {{ addon.name }}<em v-if="addon.price"> +€ {{ addon.price }}</em>
                    </li>
                  </ul>
                </template>
                € {{ detail.price }}
              </vs-list-item>
            </vs-list>
          </div>
        </vs-tab>
        <vs-tab label="Geschiedenis" v-if="activeOrder.job !== null">
          <div>
            <vs-list>
              <vs-list-item>
                <template slot="title">
                  Besteld:
                </template>
                {{ activeOrder.ordered_at_date }} {{ activeOrder.ordered_at }}
              </vs-list-item>
              <vs-list-item v-if="activeOrder.job !== null && activeOrder.job.assigned_at !== null">
                <template slot="title">
                  Toegewezen:
                </template>
                {{ $moment(Number(activeOrder.job.assigned_at)).calendar() }}
              </vs-list-item>
              <vs-list-item
                  v-if="activeOrder.job !== null && activeOrder.job.arrived_at_company !== null">
                <template slot="title">
                  Bij bedrijf:
                </template>
                {{ $moment(Number(activeOrder.job.arrived_at_company)).calendar() }}
              </vs-list-item>
              <vs-list-item v-if="activeOrder.job !== null && activeOrder.job.picked_up_at !== null">
                <template slot="title">
                  Opgehaald:
                </template>
                {{ $moment(Number(activeOrder.job.picked_up_at)).calendar() }}
              </vs-list-item>
              <vs-list-item v-if="activeOrder.job !== null && activeOrder.job.completed_at !== null">
                <template slot="title">
                  Voldaan:
                </template>
                {{ $moment(Number(activeOrder.job.completed_at)).calendar() }}
              </vs-list-item>
            </vs-list>
          </div>
        </vs-tab>
        <vs-tab label="Terugstortingen">
          <vs-list>
            <vs-list-item v-if="refunds === null" title="Terugstotingen laden..." subtitle></vs-list-item>
            <div v-if="refunds !== null">
              <vs-list-item v-if="refunds.length === 0" title="Geen terugstotingen gevonden" subtitle></vs-list-item>
            </div>
            <vs-list-item v-for="refund in refunds" :key="refund" :title="getRefundTitle(refund)">
              <template slot="subtitle">
                Ter waarde van €{{ refund.amount }},- {{ translateTime(refund) }} door {{
                  refund.staff.firstname
                }}
              </template>
            </vs-list-item>
          </vs-list>
        </vs-tab>
        <vs-tab label="Extra opties" class="compensation">
          <hr>
          <vs-list class="flex flex-row extra-options">
            <vs-button
                class="extraOptionCustom"
                type="flat"
                @click="openReprintPopup"
            >
              <img class="imageAdjustments" src="../Orders/popupIcons/bill.png" alt="Reprint">
              <span class="block">Opnieuw afdrukken</span>
            </vs-button>
            <vs-button
                class="extraOptionCustom"
                type="flat"
                @click="openAfterDeliveryPopup"
            >
              <img class="imageAdjustments" src="../Orders/popupIcons/food-delivery.png"
                   alt="Delivery man">
              <span class="block">Nalevering</span>
            </vs-button>
            <vs-button
                class="extraOptionCustom"
                type="flat"
                @click="openPartialReturnPopup"
            >
              <img class="imageAdjustments" src="../Orders/popupIcons/cash.png" alt="Partial return">
              <span class="block">Gedeeltelijk terugstorten</span>
            </vs-button>
            <!--                        <vs-list-item>-->

          </vs-list>
          <hr>
          <vs-list class="flex flex-row extra-options">
            <vs-button
                class="extraOptionCustom"
                type="flat"
                @click="openCompensateRestaurantPopup"
            >
              <img class="imageAdjustments" src="../Orders/popupIcons/credit-card.png"
                   alt="Compensate restaurant">
              <span class="block">Restaurant compenseren</span>
            </vs-button>
            <vs-button
                class="extraOptionCustom"
                type="flat"
                @click="openCompensateCustomerPopup"
            >
              <img class="imageAdjustments" src="../Orders/popupIcons/food.png" alt="Compensate customer">
              <span class="block">Klant compenseren</span>
            </vs-button>

            <vs-button
                class="extraOptionCustom"
                type="flat"
                @click="openCancelOrderPopup"
            >
              <img class="imageAdjustments" src="../Orders/popupIcons/delivery-man.png"
                   alt="Delivery man">
              <span class="block">Annuleren</span>
            </vs-button>
          </vs-list>
        </vs-tab>
      </vs-tabs>
    </vs-popup>
    <ht-after-popup></ht-after-popup>
    <ht-partial-popup></ht-partial-popup>
    <ht-compensate-popup></ht-compensate-popup>
    <ht-ccompensate-popup></ht-ccompensate-popup>
    <ht-cancel-popup></ht-cancel-popup>
    <ht-reprint-popup></ht-reprint-popup>
  </div>
</template>
<script>

import PartialReturnPopup from "./Popups/PartialReturnPopup";
import AfterDeliveryPopup from "./Popups/AfterDeliveryPopup";
import CompensateRestaurantPopup from "./Popups/CompensateRestaurantPopup";
import CompensateCustomerPopup from "./Popups/CompensateCustomerPopup";
import CancelOrderPopup from "./Popups/CancelOrderPopup";
import ReprintPopup from "./Popups/ReprintPopup";

export default {
  components: {
    "ht-partial-popup": PartialReturnPopup,
    "ht-after-popup": AfterDeliveryPopup,
    "ht-compensate-popup": CompensateRestaurantPopup,
    "ht-ccompensate-popup": CompensateCustomerPopup,
    "ht-cancel-popup": CancelOrderPopup,
    "ht-reprint-popup": ReprintPopup
  },
  data() {
    return {
      selected: [],
      orders: [],
      itemsPerPage: 20,
      isMounted: false,
      addNewDataSidebar: false,
      sidebarData: {},
      total: 4,
      activeOrder: null,
      popupActive: false,
      refunds: null
    };
  },
  computed: {
    currentPage() {
      if (this.isMounted) {
        return this.$refs.table.currentx;
      }
      return 0;
    },
    queriedItems() {
      return this.$refs.table ? this.$refs.table.queriedResults.length : this.orders.length;
    },
    staffRoute() {
      if (this.$route.meta.staff) {
        if (localStorage.getItem('stafftoken') !== null) {
          return true;
        }
      } else {
        if (localStorage.getItem('stafftoken') !== null) {
          return true;
        }
        return false;
      }
    },
    activeOrderTitle: function () {
      if (this.activeOrder !== null) {
        return 'Bestelnummer #' + this.activeOrder.id;
      }
    }
  },
  watch: {
    $route(to, from) {
      // react to route changes...
      if (to.params.slug !== null) {
        this.getOrders();
      }
    },
    popupActive() {
      if (!this.popupActive) {
        this.refunds = null;
      }
    }
  },
  methods: {
    getRefundTitle(refund) {
      return "Terugstorting door " + (refund.refund_by_hebtrek === 1 ? "Hebtrek.nl" : "restaurant");
    },
    translateTime(time) {
      return this.$moment(time.created_at).calendar();
    },
    getOrders(e) {
      let url = 'https://staffapi.hebtrek.nl/v1/orders';
      if (e !== null && e !== undefined) {
        url += '?page=' + e;
      }
      this.$http.get(url, {
        headers: {
          Authorization: 'Bearer ' + JSON.parse(localStorage.getItem('stafftoken'))
        }
      }).then((response) => {
        this.orders = response.data.data;
        this.total = response.data.meta.total;
        this.itemsPerPage = response.data.meta.per_page;
      }).catch((error) => {
        this.$util.logError(error, this.$vs);
      });
    },
    handleSearch(search) {
      let url = 'https://staffapi.hebtrek.nl/v1/orders/search';
      url += '?page=' + this.currentPage;
      this.$http.get(url, {
        headers: {
          Authorization: 'Bearer ' + JSON.parse(localStorage.getItem('stafftoken'))
        },
        params: {
          regex: search.toString()
        }
      }).then((response) => {
        this.orders = response.data.data.reverse();
        this.total = response.data.meta.total;
        this.itemsPerPage = response.data.meta.per_page;
      }).catch((error) => {
        this.$util.logError(error, this.$vs);
      });
    },
    addNewData() {
      this.sidebarData = {};
      this.toggleDataSidebar(true);
    },
    openPartialReturnPopup() {
      this.$events.fire('open-partial-modal', this.activeOrder);
      this.popupActive = false;
    },
    getRefunds(order) {
      this.$http.get("v1/order/refunds?order_id=" + order.id, {
        headers: {
          Authorization: 'Bearer ' + JSON.parse(localStorage.getItem('stafftoken'))
        },
      }).then((response) => {
        this.refunds = response.data.refunds;
      }).catch((error) => {
        this.$util.logError(error, this.$vs);
      });
    },
    openAfterDeliveryPopup() {
      this.$events.fire('open-after-modal', this.activeOrder);
      this.popupActive = false;
    },
    openCompensateRestaurantPopup() {
      this.$events.fire('open-compensate-modal', this.activeOrder);
      this.popupActive = false;
    },
    openCompensateCustomerPopup() {
      this.$events.fire('open-ccompensate-modal', this.activeOrder);
      this.showPopup = false;
    },
    openCancelOrderPopup() {
      this.popupActive = false;
      this.$events.fire('open-cancel-modal', this.activeOrder)
    },
    openReprintPopup() {
      let data = new FormData();
      data.append("orderId", this.activeOrder.id);
      this.$http
          .post("v1/company/order/reprint", data, {
            headers: {
              Authorization:
                  "Bearer " + JSON.parse(localStorage.getItem("stafftoken")),
            },
          })
          .then(() => {
            this.showPopup = false;
            this.$util.notify('Gelukt', 'Order is opieuw afgedrukt', this.$vs);
          })
          .catch((error) => {
            this.$util.logError(error, this.$vs);
          });
    },
    editData(data) {
      this.activeOrder = data;
      this.getRefunds(data);
      this.popupActive = true;
    },
    getOrderStatusColor(status) {
      if (status === 'on_hold') return 'warning';
      if (status === 'delivered') return 'success';
      if (status === 'canceled') return 'danger';
      return 'primary';
    },
    getPopularityColor(num) {
      if (num > 90) return 'success';
      if (num > 70) return 'primary';
      if (num >= 50) return 'warning';
      if (num < 50) return 'danger';
      return 'primary';
    },
    toggleDataSidebar(val = false) {
      this.addNewDataSidebar = val;
    },
    getStatus(order) {
      if (order !== null) {
        var str = "";
        if (order.status == "accepted" || order.status == "sent") {
          if (order.job !== null) {
            if (order.job.arrived_at_company !== null) {
              if (
                  order.job.assigned_at !== null &&
                  order.job.arrived_at_company == null &&
                  order.job.picked_up_at == null &&
                  order.job.completed_at == null
              ) {
                str = "Gekoppeld";
              }
              if (
                  order.job.assigned_at !== null &&
                  order.job.arrived_at_company !== null &&
                  order.job.picked_up_at == null &&
                  order.job.completed_at == null
              ) {
                str = "Bij bedrijf";
              }
              if (
                  order.job.assigned_at !== null &&
                  order.job.arrived_at_company !== null &&
                  order.job.picked_up_at !== null &&
                  order.job.completed_at == null
              ) {
                str = "Opgehaald";
              }
              if (
                  order.job.assigned_at !== null &&
                  order.job.arrived_at_company !== null &&
                  order.job.picked_up_at !== null &&
                  order.job.completed_at !== null
              ) {
                str = "Voldaan";
              }
            } else {
              if (
                  order.job.assigned_at !== null &&
                  order.job.picked_up_at == null &&
                  order.job.completed_at == null
              ) {
                str = "Gekoppeld";
              }
              if (
                  order.job.assigned_at !== null &&
                  order.job.picked_up_at !== null &&
                  order.job.completed_at == null
              ) {
                str = "Opgehaald";
              }
              if (
                  order.job.assigned_at !== null &&
                  order.job.picked_up_at !== null &&
                  order.job.completed_at !== null
              ) {
                str = "Voldaan";
              }
            }
          } else {
            str = order.status;
          }
        } else {
          str = order.status;
        }
        return str;
      }
    }
  },
  created() {

  },
  mounted() {
    this.isMounted = true;
    this.getOrders();
  },
};
</script>

<style lang="scss">
hr {
  opacity: .50;
}

#data-list-thumb-view {
  .vs-con-table {

    .order-name {
      max-width: 23rem;
    }

    .vs-table--header {
      display: flex;
      flex-wrap: wrap-reverse;
      margin-left: 1.5rem;
      margin-right: 1.5rem;

      > span {
        display: flex;
        flex-grow: 1;
      }

      .vs-table--search {
        padding-top: 0;

        .vs-table--search-input {
          padding: 0.9rem 2.5rem;
          font-size: 1rem;

          & + i {
            left: 1rem;
          }

          &:focus + i {
            left: 1rem;
          }
        }
      }
    }

    .vs-table {
      border-collapse: separate;
      border-spacing: 0 1.3rem;
      padding: 0 1rem;


      tr {
        box-shadow: 0 4px 20px 0 rgba(0, 0, 0, .05);

        td {
          padding: 10px;

          &:first-child {
            border-top-left-radius: .5rem;
            border-bottom-left-radius: .5rem;
          }

          &:last-child {
            border-top-right-radius: .5rem;
            border-bottom-right-radius: .5rem;
          }

          &.img-container {
            width: 1rem;
            background: #fff;

            span {
              display: flex;
              justify-content: flex-start;
            }

            .order-img {
              max-height: 100px;
              max-width: 100px;
            }
          }
        }

        td.td-check {
          padding: 20px !important;
        }
      }
    }

    .vs-table--thead {
      th {
        padding-top: 0;
        padding-bottom: 0;

        .vs-table-text {
          text-transform: uppercase;
          font-weight: 600;
        }
      }

      th.td-check {
        padding: 0 15px !important;
      }

      tr {
        background: none;
        box-shadow: none;
      }
    }

    .vs-table--pagination {
      justify-content: center;
    }
  }
}

.compensation .vs-list .vs-list--slot {
  margin: 0 !important;
}

.extraOptionCustom {
  float: left;
  padding: 5px !important;
  width: 300px;

  .vs-list--slot {
    margin-right: auto;
  }
}

.extraOptionsCustom {
  vertical-align: middle;
  padding: 0 !important;

  color: black;
}

.oa {
}

.extra-options {
  display: flex;
  justify-content: space-around;

  .vs-list-item .vs-button {
    display: flex;
    justify-content: space-around;
    padding: 0 !important;
  }

  .block {
    color: #000;
  }

  img {
    height: 5em;
    width: 5em;
  }
}
</style>
